// extracted by mini-css-extract-plugin
module.exports = {"footer-inner":"Footer_footer-inner__11QUr","footer-social":"Footer_footer-social__3PxU8","footer-item-right":"Footer_footer-item-right__2rpkB"};